module.exports = __webpack_public_path__ + "img/feature-1-new-york-mobile.36f82cc0.png";